import { Button, Calendar, Heading, Text } from "@athena/ui";

interface StepScheduleProps {
    fixedDate: Date | undefined;
    setFixedDate: (date: Date | undefined) => void;
    // sendNudges: boolean;
    // setSendNudges: (v: boolean) => void;
}

export const StepSchedule = ({ fixedDate, setFixedDate }: StepScheduleProps) => {
    return (
        <div className="flex flex-col gap-6">
            <div>
                <Heading level={3}>When is it due?</Heading>
                <Text muted className="text-sm">
                    Set a deadline, or leave it blank — an assignment does not need one.
                </Text>
            </div>

            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <Text weight="semibold" className="text-sm">
                        Due date <span className="text-muted-foreground font-normal">(optional)</span>
                    </Text>
                    {/*
                     * The only way back to no date. `Calendar` in single mode does not deselect on
                     * a second click, so without this a mis-clicked day is permanent for the life
                     * of the dialog — and the operator would have to cancel and start again to
                     * assign without a deadline.
                     */}
                    {fixedDate ? (
                        <Button variant="ghost" size="sm" onClick={() => setFixedDate(undefined)}>
                            Clear
                        </Button>
                    ) : null}
                </div>
                <Calendar
                    className="w-90 rounded-lg border p-4 [--cell-size:2.25rem]"
                    classNames={{
                        caption_label: "text-base font-bold",
                        button_previous:
                            "border-border rounded-md border bg-transparent hover:bg-muted h-6.5 w-6.5 p-0",
                        button_next: "border-border rounded-md border bg-transparent hover:bg-muted h-6.5 w-6.5 p-0",
                        today: "font-bold",
                    }}
                    mode="single"
                    onSelect={setFixedDate}
                    selected={fixedDate}
                    disabled={{ before: new Date() }}
                />
            </div>

            {/* <div className="bg-muted/50 border-border flex items-center gap-4 rounded-xl border px-5 py-4">
                <Switch checked={sendNudges} onCheckedChange={setSendNudges} />
                <div>
                    <Text weight="semibold" className="text-sm">
                        Send reminder nudges
                    </Text>
                    <Text muted className="text-xs">
                        A gentle reminder at 7 days, 3 days, and on the due date.
                    </Text>
                </div>
            </div> */}
        </div>
    );
};
